import { styled } from '@mui/material/styles';
import { Stack, Card, Link, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import RegisterForm from './RegisterForm';

import MHidden from '../../Components/Mhidden';
import Logo from '../../Components/Logo';
import LoginSvg from '../../assets/svgs/login.svg';

// Styled Components

const RootStyle = styled('div')(({ theme }) => ({
	[theme.breakpoints.up('md')]: {
		display: 'flex',
		height: '100vh',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%'
	}
}));

const SectionStyle = styled(Card)(({ theme }) => ({
	width: '100%',
	maxWidth: 464,
	maxHeight: '100vh',
	minHeight: '90vh',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	margin: theme.spacing(2, 0, 2, 2),
	boxShadow: 16
}));

const ContentStyle = styled('div')(({ theme }) => ({
	maxWidth: 480,
	margin: 'auto',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	padding: theme.spacing(12, 0),
	color: theme.palette.primary.main
}));

export default function Register() {
	return (
		<RootStyle>
			<MHidden width="mdDown">
				<SectionStyle>
					<img src={LoginSvg} alt="login" />
				</SectionStyle>
			</MHidden>

			<Container>
				<ContentStyle>
					<Stack sx={{ mb: 5 }}>
						<Typography variant="h4" gutterBottom fontWeight="bold">
							Get started with Framerate Dashboard
						</Typography>
						<Typography sx={{ color: 'text.secondary' }}>Enter your details below.</Typography>
					</Stack>

					<RegisterForm />

					<Typography variant="body2" align="center" sx={{ color: 'text.secondary', mt: 3 }}>
						By registering, I agree to &nbsp;
						<Link underline="always" sx={{ color: 'text.primary' }}>
							Terms of Service
						</Link>
						&nbsp;and&nbsp;
						<Link underline="always" sx={{ color: 'text.primary' }}>
							Privacy Policy
						</Link>
						.
					</Typography>

					<Link
						variant="subtitle1"
						sx={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}
						component={RouterLink}
						to="/login"
					>
						Already have an account? Log In
					</Link>
				</ContentStyle>
			</Container>
		</RootStyle>
	);
}
